import { FC, useCallback, useEffect } from 'react';
import { SlotButton } from 'shared/ui/buttons/slotButton/slotButton';
import { TimeslotMapItem } from '../../model/types';
import { Container, Timeslot } from './styles';
import { formatTime } from 'shared/lib/time';
import {
	scrollToSlot,
	selectSelectedTimeslot,
} from '../..';
import { useAppSelector } from 'shared/lib/store';

interface TimeslotsListProps {
	time: string;
	slots: TimeslotMapItem[];
	selectSlot: (slot: TimeslotMapItem) => void;
	isLast?: boolean
}

export const TimeslotsList: FC<TimeslotsListProps> = ({
	time = '',
	slots = [],
	selectSlot,
	isLast,
}) => {
	const selectedSlot = useAppSelector(selectSelectedTimeslot);

	const isOpenGroup = selectedSlot ? (Number(time) === new Date(selectedSlot).getHours()) : false;

	const onGroupSelect = useCallback(() => {
		if (!isOpenGroup) {
			selectSlot(slots[0]);
		}
	}, [isOpenGroup, slots, selectSlot])

	useEffect(() => {
		const formattedTime = formatTime({ byUtc: false });
		if (formattedTime && time === formattedTime?.hours) {
			scrollToSlot(formattedTime?.hours);
		}
	}, [time, slots]);

	return (
		<Container
			data-testid="slots-box"
			onClick={onGroupSelect}
			$isLast={isLast}
		>
			<Timeslot
				id={`hour-${time}`}
				role={`hour-${time}`}
			>
				{time}
			</Timeslot>
			{slots.map((slot: TimeslotMapItem) => {
				return (
					<SlotButton
						key={slot.dt_start}
						isOpen={isOpenGroup}
						isSelected={slot.dt_start === selectedSlot}
						color={slot.color}
						onClick={() => selectSlot(slot)}
					>
						{slot.time}
					</SlotButton>
				);
			})}
		</Container>
	);
};
